import { revalidateLogic, useForm } from '@tanstack/react-form';
import { registerCodeSchema, registerSchema } from '../schemas/auth';
import { ValidateFormRefObject } from './useAuthForm';
import { useTanstackFormErrors } from '#app/hooks/useTanstackFormErrors';

/** Серверные ошибки снимаются в handleSubmit (clearServerErrors) — как useAccountTanstackForm. */

interface UseRegisterFormParams {
  initialEmail?: string;
  isCodeStep: boolean;
  onSubmit: (values: Record<string, any>, obj: ValidateFormRefObject) => void;
}

export function useRegisterForm({
  initialEmail = '',
  isCodeStep,
  onSubmit,
}: UseRegisterFormParams) {
  const schema = isCodeStep ? registerCodeSchema : registerSchema;

  const tanstackForm = useForm({
    defaultValues: {
      email: initialEmail,
      password: '',
      password_confirmation: '',
      captchaValue: '',
      code: '',
      role: 'client',
      promo_code: '',
      form: 'client',
    },
    validationLogic: revalidateLogic({
      mode: 'change',
      modeAfterSubmission: 'change',
    }),
    validators: {
      onChange: schema as any,
      onSubmit: schema as any,
    },
    canSubmitWhenInvalid: true,
    onSubmit: handleFormSubmit,
  });

  const { setServerErrors, clearServerErrors, hasClientErrors, hasServerErrors } =
    useTanstackFormErrors(tanstackForm);

  function handleFormSubmit({ value }: { value: Record<string, string> }) {
    if (hasClientErrors && !hasServerErrors) return;
    onSubmit(value, validateFormObj);
  }
  // Объект-адаптер для передачи в саги (withValidateForm из laravel-request).
  const validateFormObj: ValidateFormRefObject = {
    state: { formErrors: {} },
    setState: (updater) => {
      if (typeof updater === 'function') {
        const next = updater({ formErrors: {} });
        setServerErrors(next?.formErrors ?? {});
      }
    },
  };

  const handleSubmit = () => {
    clearServerErrors();
    tanstackForm.handleSubmit();
  };

  return {
    tanstackForm,
    handleSubmit,
    validateFormObj,
  };
}
